
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row" [hidden]="!error">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <form #createCustomerForm="ngForm" (ngSubmit)="createCustomer()">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="col">
            <h4>Create K2 Customer</h4>
          </div>
          <div class="col">
            <div class="btn-group float-right">
              <button class="btn btn-primary" type="submit">Create customer</button><a class="btn btn-outline-secondary" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/' + this.workflowTargetInfo.stepName">Back</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required" for="name">Customer name:</label>
            <input class="form-control" id="name" type="text" [(ngModel)]="customer.name" name="name" maxlength="150" required>
          </div>
          <div class="form-group col-lg-6">
            <label class="required">Billing destination:</label>
            <select class="form-control" type="text" [(ngModel)]="customer.billDestination" name="billDestination" maxlength="100" required>
              <option value=""></option>
              <option *ngFor="let destination of billingDestinations" [ngValue]="destination.key">{{ destination.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required">Contract Number:</label>
            <input class="form-control" id="contractNumber" type="text" [(ngModel)]="customer.contractNumber" name="contractNumber" maxlength="70" required>
          </div>
          <div class="form-group col-lg-6">
            <label class="required">Pricing Model:</label>
            <select class="form-control" type="text" [(ngModel)]="customer.pricingModel" name="pricingModel" maxlength="100" required>
              <option value=""></option>
              <option *ngFor="let pricingModel of pricingModels" [ngValue]="pricingModel.key">{{ pricingModel.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label>Custom Heading 1:</label>
            <input class="form-control" id="customerHeading1" type="text" [(ngModel)]="customer.customHeading1" name="customHeading1" maxlength="70">
          </div>
          <div class="form-group col-lg-6">
            <label>Custom Heading 2:</label>
            <input class="form-control" id="customerHeading2" type="text" [(ngModel)]="customer.customHeading2" name="customHeading2" maxlength="70">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label>Custom Heading 3:</label>
            <input class="form-control" id="customerHeading3" type="text" [(ngModel)]="customer.customHeading3" name="customHeading3" maxlength="70">
          </div>
          <div class="form-group col-lg-6">
            <label>Custom Heading 4:</label>
            <input class="form-control" id="customerHeading4" type="text" [(ngModel)]="customer.customHeading4" name="customHeading4" maxlength="70">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label>Custom Heading 5:</label>
            <input class="form-control" id="customerHeading5" type="text" [(ngModel)]="customer.customHeading5" name="customHeading5" maxlength="70">
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <input type="checkbox" [(ngModel)]="customer.billingActive" autoLinkToLabel name="billingActive">
              <label class="form-check-label">Active Billing</label>
            </div>
            <div class="form-group">
              <input type="checkbox" [(ngModel)]="customer.custAllSapServer" autoLinkToLabel name="custAllSapServer">
              <label class="form-check-label">CustAllSapServer</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h4>Default flags for new areas & groups</h4>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-check col-lg-6">
              <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doUsageCollection" (change)="usageCollectionChanged()" autoLinkToLabel name="doUsageCollection">
              <label class="form-check-label">Enable Usage</label>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!isEmea" [hidden]="!customer.doUsageCollection">
          <div class="col">
            <div class="form-group">
              <label>Toner</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doTonerMonitoring" autoLinkToLabel name="doTonerMonitoring">
                <label class="form-check-label">Monitor</label>
              </div>
              <div class="form-check" [hidden]="!customer.doTonerMonitoring">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doTonerAutoOrder" autoLinkToLabel name="doTonerAutoOrder">
                <label class="form-check-label">ASM</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Ink</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doInkMonitoring" autoLinkToLabel name="doInkMonitoring">
                <label class="form-check-label">Monitor</label>
              </div>
              <div class="form-check" [hidden]="!customer.doInkMonitoring">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doInkAutoOrder" autoLinkToLabel name="doInkAutoOrder">
                <label class="form-check-label">ASM</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Longlife</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doPrintHeadMonitoring" autoLinkToLabel name="doPrintHeadMonitoring">
                <label class="form-check-label">Monitor</label>
              </div>
              <div class="form-check" [hidden]="!customer.doPrintHeadMonitoring">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doPrintHeadAutoOrder" autoLinkToLabel name="doPrintHeadAutoOrder">
                <label class="form-check-label">ASM</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Maintenance</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doMaintenanceMonitoring" autoLinkToLabel name="doMaintenanceMonitoring">
                <label class="form-check-label">Monitor</label>
              </div>
              <div class="form-check" [hidden]="!customer.doMaintenanceMonitoring">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doMaintenanceAutoOrder" autoLinkToLabel name="doMaintenanceAutoOrder">
                <label class="form-check-label">ASM</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Fasteners</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doFastenerMonitoring" autoLinkToLabel name="doFastenerMonitoring">
                <label class="form-check-label">Monitor</label>
              </div>
              <div class="form-check" [hidden]="!customer.doFastenerMonitoring">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doFastenerAutoOrder" autoLinkToLabel name="doFastenerAutoOrder">
                <label class="form-check-label">ASM</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isEmea" [hidden]="!customer.doUsageCollection">
          <div class="col">
            <div class="form-group">
              <label>EMEA Toner-Ink</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doTonerMonitoring" (change)="emeaTonerChanged()" autoLinkToLabel name="doTonerMonitoringEMEA">
                <label class="form-check-label">Monitor</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Longlife</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doPrintHeadMonitoring" (change)="emeaPrintHeadChanged()" autoLinkToLabel name="doPrintHeadMonitoringEMEA">
                <label class="form-check-label">Monitor</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Maintenance</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doMaintenanceMonitoring" autoLinkToLabel name="doMaintenanceMonitoringEMEA">
                <label class="form-check-label">Monitor</label>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Fasteners</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="customer.doFastenerMonitoring" (change)="emeaFastenerChanged()" autoLinkToLabel name="doFastenerMonitoringEMEA">
                <label class="form-check-label">Monitor</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>